export const QUIZ_TEMPLATES = {
  SINGLE: 'single_choice',
  MULTIPLE: 'multiple_choice',
};

export function createEmptyQuizOption(index = 0) {
  return {
    id: `opt_${String.fromCharCode(97 + index)}`,
    text: '',
    correct: false,
  };
}

export function createDefaultQuizOptions() {
  return [createEmptyQuizOption(0), createEmptyQuizOption(1)];
}

function nextOptionId(existingIds) {
  let index = 0;
  while (index < 26) {
    const id = `opt_${String.fromCharCode(97 + index)}`;
    if (!existingIds.includes(id)) return id;
    index += 1;
  }
  return `opt_${Date.now()}`;
}

export function addQuizOption(options) {
  const existingIds = options.map((option) => option.id);
  return [
    ...options,
    {
      id: nextOptionId(existingIds),
      text: '',
      correct: false,
    },
  ];
}

export function removeQuizOption(options, optionId) {
  if (options.length <= 2) return options;
  return options.filter((option) => option.id !== optionId);
}

export function buildQuizQuestionData({
  question,
  options,
  template,
  explanation,
  subtopicId,
  level,
}) {
  const contentOptions = options.map((option, index) => ({
    id: option.id || `opt_${String.fromCharCode(97 + index)}`,
    text: String(option.text || '').trim(),
  }));
  const correctOptionIds = options
    .filter((option) => option.correct)
    .map((option, index) => option.id || `opt_${String.fromCharCode(97 + index)}`);

  return {
    metadata: {
      subtopic_id: subtopicId,
      level,
      template:
        template === QUIZ_TEMPLATES.MULTIPLE
          ? QUIZ_TEMPLATES.MULTIPLE
          : QUIZ_TEMPLATES.SINGLE,
    },
    content: {
      question: String(question || '').trim(),
      options: contentOptions,
    },
    answer: {
      correct_option_ids: correctOptionIds,
      explanation: String(explanation || '').trim(),
    },
  };
}

export function parseQuizQuestionData(jsonData = {}) {
  const metadata = jsonData.metadata || {};
  const content = jsonData.content || {};
  const answer = jsonData.answer || {};
  const correctIds = new Set(answer.correct_option_ids || []);
  const options = Array.isArray(content.options)
    ? content.options.map((option, index) => ({
        id: option.id || `opt_${String.fromCharCode(97 + index)}`,
        text: option.text || '',
        correct: correctIds.has(option.id),
      }))
    : createDefaultQuizOptions();

  return {
    question: content.question || '',
    options: options.length >= 2 ? options : createDefaultQuizOptions(),
    template:
      metadata.template === QUIZ_TEMPLATES.MULTIPLE
        ? QUIZ_TEMPLATES.MULTIPLE
        : QUIZ_TEMPLATES.SINGLE,
    explanation: answer.explanation || '',
    tags: jsonData.Tags || jsonData.tags || [],
  };
}

export function validateQuizForm({ question, options, explanation, template }) {
  if (!String(question || '').trim()) {
    return 'Please enter Question';
  }
  if (!Array.isArray(options) || options.length < 2) {
    return 'Please add at least two options';
  }
  if (options.some((option) => !String(option.text || '').trim())) {
    return 'Please fill all the options';
  }
  const correctCount = options.filter((option) => option.correct).length;
  if (template === QUIZ_TEMPLATES.MULTIPLE) {
    if (correctCount < 1) return 'Please select at least one correct answer';
  } else if (correctCount !== 1) {
    return 'Please select exactly one correct answer';
  }
  if (!String(explanation || '').trim()) {
    return 'Please enter Explanation';
  }
  return '';
}
